import React from "react"

type Props = {
  className: string
  label: string
  symbol: string
}

const Emoji = ({ className, label, symbol }: Props) => (
  <span
    aria-label={label}
    className={className}
    role='img'
  >
    {symbol}
  </span>
)

export default Emoji

